// angular
import { Component, input } from '@angular/core';
// components
import { MediaVideosGridComponent } from '@app/core/components/media-videos-grid/media-videos-grid.component';
// interfaces
import { IMedia } from '@app/shared/interfaces/media.interface';

@Component({
  selector: 'pwj-product-videos-section',
  standalone: true,
  imports: [MediaVideosGridComponent],
  templateUrl: './product-videos-section.component.html',
})
export class ProductVideosSectionComponent {
  videos = input.required<IMedia[]>();
}
